const authConstants = {
    AUTH_REQUEST: 'AUTH_REQUEST',
    AUTH_SUCCESS: 'AUTH_SUCCESS',
    AUTH_FAILED: 'AUTH_FAILED',
};

const notesConstants = {
    CREATE_NOTE_REQUEST: 'CREATE_NOTE_REQUEST',
    CREATE_NOTE_SUCCESS: 'CREATE_NOTE_SUCCESS',
    CREATE_NOTE_FAILED: 'CREATE_NOTE_FAILED',

    GET_ALL_NOTES_REQUEST: 'GET_ALL_NOTES_REQUEST',
    GET_ALL_NOTES_SUCCESS: 'GET_ALL_NOTES_SUCCESS',
    GET_ALL_NOTES_FAILED: 'GET_ALL_NOTES_FAILED',

    GET_NOTE_DETAILS_BY_ID_REQUEST: 'GET_NOTE_DETAILS_BY_ID_REQUEST',
    GET_NOTE_DETAILS_BY_ID_SUCCESS: 'GET_NOTE_DETAILS_BY_ID_SUCCESS',
    GET_NOTE_DETAILS_BY_ID_FAILED: 'GET_NOTE_DETAILS_BY_ID_FAILED',

    UPDATE_NOTE_BY_ID_REQUEST: 'UPDATE_NOTE_BY_ID_REQUEST',
    UPDATE_NOTE_BY_ID_SUCCESS: 'UPDATE_NOTE_BY_ID_SUCCESS',
    UPDATE_NOTE_BY_ID_FAILED: 'UPDATE_NOTE_BY_ID_FAILED',

    DELETE_NOTE_BY_ID_REQUEST: 'DELETE_NOTE_BY_ID_REQUEST',
    DELETE_NOTE_BY_ID_SUCCESS: 'DELETE_NOTE_BY_ID_SUCCESS',
    DELETE_NOTE_BY_ID_FAILED: 'DELETE_NOTE_BY_ID_FAILED',
};

const sharingConstants = {
    GET_ALL_SHARED_NOTES_REQUEST: 'GET_ALL_SHARED_NOTES_REQUEST',
    GET_ALL_SHARED_NOTES_SUCCESS: 'GET_ALL_SHARED_NOTES_SUCCESS',
    GET_ALL_SHARED_NOTES_FAILED: 'GET_ALL_SHARED_NOTES_FAILED',

    GET_SHARED_NOTE_DETAILS_BY_SHARING_ID_REQUEST: 'GET_SHARED_NOTE_DETAILS_BY_SHARING_ID_REQUEST',
    GET_SHARED_NOTE_DETAILS_BY_SHARING_ID_SUCCESS: 'GET_SHARED_NOTE_DETAILS_BY_SHARING_ID_SUCCESS',
    GET_SHARED_NOTE_DETAILS_BY_SHARING_ID_FAILED: 'GET_SHARED_NOTE_DETAILS_BY_SHARING_ID_FAILED',

    SHARE_NOTE_REQUEST: 'SHARE_NOTE_REQUEST',
    SHARE_NOTE_SUCCESS: 'SHARE_NOTE_SUCCESS',
    SHARE_NOTE_FAILED: 'SHARE_NOTE_FAILED',

    UPDATE_SHARED_NOTE_BY_SHARING_ID_REQUEST: 'UPDATE_SHARED_NOTE_BY_SHARING_ID_REQUEST',
    UPDATE_SHARED_NOTE_BY_SHARING_ID_SUCCESS: 'UPDATE_SHARED_NOTE_BY_SHARING_ID_SUCCESS',
    UPDATE_SHARED_NOTE_BY_SHARING_ID_FAILED: 'UPDATE_SHARED_NOTE_BY_SHARING_ID_FAILED',

    MY_SHARED_USERS_REQUEST: 'MY_SHARED_USERS_REQUEST',
    MY_SHARED_USERS_SUCCESS: 'MY_SHARED_USERS_SUCCESS',
    MY_SHARED_USERS_FAILED: 'MY_SHARED_USERS_FAILED',
};

export { authConstants, notesConstants, sharingConstants };
